export default __webpack_public_path__ + "static/media/Picture6.571ebfad.png";